import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UISection from 'UIComponents/section/UISection';
import { GYPSUM, LORAX, OBSIDIAN } from 'HubStyleTokens/colors';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useEffect, useMemo, useState } from 'react'; // @ts-expect-error Could not find a declaration file for module

import Carousel from '../Carousel';
import { useHistory, useLocation } from 'react-router-dom';
import MostPopularCertificatesHeader from './MostPopularCertificatesHeader';
import CertificateButton from './CertificateButton/CertificateButton';
import CertificateButtonWrapper from './CertificateButton/CertificateButtonWrapper'; // @ts-expect-error Could not find a declaration file for module

import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import { RESULTS_URL_FRAGMENT } from '../../constants/Navigation';
import UsageTracker from '../../utils/UsageTracker';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { UserTrackStatuses } from '../../constants/TracksConstants';
import { safeSmoothScrollTo } from '../../utils/utils';
import { getOverviewModalUrl } from '../../utils/RoutingUtils';
import { useRecommendedCertificates } from '../../hooks/recommendationsHooks';
import ExpandedCertificate from './ExpandedCertificate';
import { OverviewSource } from '../../features/tracks';
import { useAssetStatus } from '../../features/userProgress';
import styled, { academyPageFullWidth, css, mediaQuery } from '../../utils/Styling';
const BackgroundColoredSection = styled(UISection).withConfig({
  displayName: "MostPopularCertificates__BackgroundColoredSection",
  componentId: "sc-1pbp8x0-0"
})(["background-color:", ";width:100%;display:flex;justify-content:center;margin-bottom:0 !important;overflow:hidden;"], GYPSUM);
const BackgroundColoredSectionContent = styled.div.withConfig({
  displayName: "MostPopularCertificates__BackgroundColoredSectionContent",
  componentId: "sc-1pbp8x0-1"
})(["", " padding:60px 48px;", ""], academyPageFullWidth, mediaQuery('mobile', css(["padding:24px 16px 16px;"])));
const StyledCertificateLink = styled(UIRouterLink).attrs(() => ({
  use: 'unstyled'
})).withConfig({
  displayName: "MostPopularCertificates__StyledCertificateLink",
  componentId: "sc-1pbp8x0-2"
})(["color:", ";font-weight:400;-webkit-font-smoothing:unset;&:hover{color:", ";text-decoration:none;}"], OBSIDIAN, OBSIDIAN);

const MostPopularCertificates = () => {
  const history = useHistory();
  const location = useLocation();
  const [selectedCertificate, setSelectedCertificate] = useState();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const {
    numCertificates,
    mostPopularCertificates
  } = useRecommendedCertificates();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id: selectedCertificate || -1
  });
  const carouselChildren = useMemo(() => [...mostPopularCertificates.slice(0, isMobile ? 4 : mostPopularCertificates.length).map(({
    id,
    name,
    isCompleted,
    isExpired,
    expiresAt,
    awardName
  }) => /*#__PURE__*/_jsx(CertificateButton, {
    awardName: awardName || '',
    expiresAt: expiresAt || 0,
    isCompleted: !!isCompleted,
    isExpired: !!isExpired,
    isSelected: selectedCertificate === id,
    name: name,
    onClick: () => {
      UsageTracker.track('interaction', {
        action: 'most-popular-certificates-track-clicked',
        id: `${id}`
      });
      setSelectedCertificate(id);
    },
    trackId: id
  }, `certificate_button_${id}`)), /*#__PURE__*/_jsx(CertificateButtonWrapper, {
    onClick: e => {
      e.stopPropagation();
      UsageTracker.track('interaction', {
        action: 'most-popular-certificates-view-all-clicked'
      });
      history.push(`${RESULTS_URL_FRAGMENT}?awardType=ONLY_SHOW_CERTIFICATE_COURSES`);
      safeSmoothScrollTo(window, 0, 0);
    },
    style: {
      borderColor: LORAX,
      color: LORAX
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.mostPopularCertificates.viewAllCertificates"
    })
  }, "view-all")], [history, isMobile, mostPopularCertificates, selectedCertificate]);
  useEffect(() => {
    if (mostPopularCertificates && mostPopularCertificates[0] && !selectedCertificate) {
      const index = mostPopularCertificates.findIndex(element => !element.isCompleted);
      setSelectedCertificate(mostPopularCertificates[index > 0 ? index : 0].id);
    }
  }, [mostPopularCertificates, selectedCertificate]);
  return mostPopularCertificates.length > 0 ? /*#__PURE__*/_jsx(BackgroundColoredSection, {
    children: /*#__PURE__*/_jsxs(BackgroundColoredSectionContent, {
      children: [/*#__PURE__*/_jsx(MostPopularCertificatesHeader, {
        numCompletedCertificates: numCertificates
      }), /*#__PURE__*/_jsx(Carousel, {
        carouselClassName: "p-bottom-0",
        children: carouselChildren
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: !!selectedCertificate,
        renderContent: () => /*#__PURE__*/_jsx(StyledCertificateLink, {
          to: status && status !== UserTrackStatuses.NOT_STARTED ? `/tracks/${selectedCertificate}` : getOverviewModalUrl(location.pathname, true, selectedCertificate, OverviewSource.Certificates),
          children: selectedCertificate && /*#__PURE__*/_jsx(ExpandedCertificate, {
            position: mostPopularCertificates.findIndex(track => track.id === selectedCertificate) + 1,
            trackId: selectedCertificate
          })
        })
      })]
    })
  }) : null;
};

export default MostPopularCertificates;